export interface IJob {
	title: string
	cities: string
	category: string
	description: string
	unbuplishDate?: string
	uri: string
}


export interface IValue {
	value: string
	selected: boolean
}

export interface ICategoryFilter {
	name: string
	identifier: string
	values: IValue[]
}
export interface ISort {
	name: string,
	fied: string,
	isDescending: boolean,
	active: boolean
}
export interface IExtraLink {
	name?: string,
	uri?: string,
}
export interface IState {
	query: string,
	jobs: IJob[],
	endpoints: {
		search: string
	},
	page: number,
	total: number,
	count: number,
	pages: number,
	categoryFilters: ICategoryFilter[],
	sort: ISort[]
	title: string,
	description: string,
	extraLinks: IExtraLink[]
}

const deafultState: IState = {
	query: '',
	jobs: [],
	page: 0,
	count: 0,
	pages: 0,
	endpoints: {
		search: ''
	},
	total: 0,
	categoryFilters: [],
	sort: [],
	title: '',
	description: '',
	extraLinks: [],
	
}

export default deafultState;
